import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { getInnerObjectsSelectedIds } from "../../documentDetails/redux/selectors";
import { getActiveDocumentId, getCalculatedDetailedPanelOpen, getProjectId } from "../redux/selectors";
import GraphPanel from "./graphPanel";
const canAddToSummaryReports = security.isAllowed([
    Permissions.SummaryReportsEdit,
    Permissions.SummaryReportsView
]);
const mapStateToProps = (state, ownProps) => ({
    documentId: getActiveDocumentId(state),
    projectId: getProjectId(state),
    selectedCount: getInnerObjectsSelectedIds(state).length,
    canAddToSummaryReports: canAddToSummaryReports &&
        (ownProps.canAddToSummaryReports !== undefined ? ownProps.canAddToSummaryReports : true),
    rightPanelOpen: getCalculatedDetailedPanelOpen(state)
});
export default connect(mapStateToProps)(GraphPanel);
